import React from "react";
import { Outlet } from "react-router-dom";
import DashboardLayout from "../components/layout/DashboardLayout";

export default function Dashboard({ user }) {
  return (
    <DashboardLayout user={user}>
      <Outlet />
    </DashboardLayout>
  );
}
